import { render, staticRenderFns } from "./TwNewsEditInner.vue?vue&type=template&id=57f6528d&scoped=true&"
import script from "./TwNewsEditInner.vue?vue&type=script&lang=js&"
export * from "./TwNewsEditInner.vue?vue&type=script&lang=js&"
import style0 from "./TwNewsEditInner.vue?vue&type=style&index=0&id=57f6528d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57f6528d",
  null
  
)

export default component.exports